<template>
  <smd-one-col-layout>
    <div class="freestylelibre-details">
      <div class="freestylelibre-details__title-author">
        <text-string label-id="txt1449"/>
        <div class="author">
          <div class="author-img-container">
            <img src="~@/assets/images/program/freestylelibre/004.png" alt="abbott">
          </div>
          <div>
            <text-string label-id="txt1450"/>
            <span class="Body3 gray-400">{{formattedDate}}</span>
          </div>
        </div>
      </div>

      <div class="freestylelibre-details__program-img">
        <img src="~@/assets/images/program/freestylelibre/006.png" alt="freestyle-libre-program-cover">
      </div>

      <div class="freestylelibre-details__details">
        <text-string label-id="txt1469"/>

        <div class="grid-details">
          <div class="detail-section-image-container">
            <img src="~@/assets/images/program/freestylelibre/008/008_Employee relations icon.png"/>
          </div>
          <text-string label-id="txt1470" class="detail-title-desc"/>
        </div>

        <div class="grid-details">
          <div class="detail-section-image-container">
            <img src="~@/assets/images/program/freestylelibre/008/008_Onboarding session icon.png"/>
          </div>
          <text-string label-id="txt1476" class="detail-title-desc"/>
        </div>

        <div class="grid-details">
          <div class="detail-section-image-container">
            <img src="~@/assets/images/program/freestylelibre/008/008_FreeStyle Libre product shot icon.png"/>
          </div>
          <text-string label-id="txt1471" class="detail-title-desc"/>
        </div>

        <div class="grid-details">
          <div class="detail-section-image-container">
            <img src="~@/assets/images/program/freestylelibre/008/008_Sensor icon.png"/>
          </div>
          <text-string label-id="txt1472" class="detail-title-desc"/>
        </div>

        <div class="grid-details">
          <div class="detail-section-image-container">
            <img src="~@/assets/images/program/freestylelibre/008/008_Sensor icon.png"/>
          </div>
          <text-string label-id="txt1473" class="detail-title-desc"/>
        </div>
      </div>
    </div>

    <smd-btn slot="bottom-nav"
              section="1"
              variant="enabled-blue"
              @click="signUp">
      <text-string label-id="txt1447"/>
    </smd-btn>
  </smd-one-col-layout>
</template>

<script>
  import moment from 'moment';
  import {mapFields} from 'vuex-map-fields';

  import {
    PROGRAM_FREESTYLELIBRE_SIGNUP,
  } from '@/reference/program';

  export default {
    name: 'freestylelibre-details',
    computed: {
      ...mapFields('program', {
        programCoupon: 'coupon',
      }),
      formattedDate() {
        return this.programCoupon.issuedate ? moment(this.programCoupon.issuedate).format('MM/DD/YYYY') : '';
      },
    },
    methods: {
      signUp() {
        this.$emit('set-active-step', PROGRAM_FREESTYLELIBRE_SIGNUP);
      },
    }
  }
</script>

<style lang="scss">
  @import "@/assets/styles/applications.scss";

  .freestylelibre-details {
    @include flex-col();
    gap: 20px;

    img {
      height: 100%;
      width: 100%;
      display: block;
    }

    &__title-author {
      @include flex-col();
      gap: 10px;

      .author {
        @extend %layout--flex-row-center-x;
        gap: 18px;

        .author-img-container {
          width: 50px;
          height: 50px;

          img {
            object-fit: contain;
          }
        }

        span {
          display: block;
        }
      }
    }

    &__program-img {
      width: 100%;
      min-height: 168px;
      border-radius: 8px;
      overflow: hidden;

      img {
        object-fit: cover;

        @include responsive(desktop) {
          width: 80%;
          margin: 0 auto;
          border-radius: 8px;
        }
      }
    }

    &__details {
      @include flex-col();
      gap: 16px;

      .grid-details {
        @include make-grid(40px 1fr, auto, 16px);
        grid-template-areas: "image title-desc";

        .detail-section-image-container {
          grid-area: image;

          &>img {
            height: 40px;
            object-fit: contain;
          }
        }

        .detail-title-desc {
          grid-area: title-desc;
        }
      }
    }

  }
</style>
